module.exports = __webpack_public_path__ + "img/undset_Stor_kunnskap_om_middelalderen.5ebde270.jpg";